import pokemonApi from "@/api/pokemonApi.js"

export const getPokemons = () => {

    const pokemonsArr = Array.from(Array(649))

    return pokemonsArr.map( ( _ , index) => index + 1 )
}

const getPokemonOptions = async() => {

    const mixedPokemons = getPokemons().sort( () => Math.random() - 0.5)
    
    const pokemons = await getPokemonNames(mixedPokemons.splice(0, 4))

    return pokemons;
}

export const getPokemonNames = async( [a, b, c, d] = []) => {

    const arrPromises = [
        pokemonApi.get(`/${a}`),
        pokemonApi.get(`/${b}`),
        pokemonApi.get(`/${c}`),
        pokemonApi.get(`/${d}`),
    ]

    const [p1, p2, p3, p4] = await Promise.all(arrPromises)

    return[
        {name: setFirstCaseUpper(p1.data.name), id: p1.data.id},
        {name: setFirstCaseUpper(p2.data.name), id: p2.data.id},
        {name: setFirstCaseUpper(p3.data.name), id: p3.data.id},
        {name: setFirstCaseUpper(p4.data.name), id: p4.data.id},
    ]
}

const setFirstCaseUpper = (name) => {

    let newName = ''

    for(let i = 0; i<name.length; i++){

        if(i == 0){
            newName += name[i]
            newName = newName.toUpperCase()
        }else{
            newName += name[i]
        }
    }

    return newName
}

export default getPokemonOptions